import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ColorSVG } from '@common_components/svg/color.svg';

const ColorIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ColorSVG/>
    </div>
  );
};

export { ColorIcon };
